import {
  Button,
  Image,
  Modal,
  Row,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import "./CustomTermsModal.css";
import CVVImage from "../../../assests/card-cvv.jpg";
import AmericanCardImage from "../../../assests/american-card-cvv.png";
const { Text } = Typography;
const CustomTermsModal = ({
  termsRequest,
  setTermsRequest,
  modalType,
  handleRemoveTerms,
  allWaitingProducts,
  allApprovedProducts,
  allRejectedProducts,
  waitingAndApproved,
  waitingAndRejected,
  approvedAndRejected,
  mixedStatusProducts,
  isExpired,
}) => {
  const handleClose = () => {
    setTermsRequest(false);
  };
  const renderedComponent = () => {
    switch (modalType) {
      case "withdraw":
        return (
          <div>
            <Text className="once-withdraw-paragraph">
              {allWaitingProducts
                ? "You’re withdrawing your custom payment plan request before sellers have responded."
                : allApprovedProducts
                ? "You’re withdrawing your custom payment plan request, even though all products have been approved."
                : allRejectedProducts
                ? "You’re withdrawing your custom payment plan request, which has been rejected for all products."
                : waitingAndApproved
                ? "You’re withdrawing your custom payment plan request while some products are approved and others are still pending."
                : waitingAndRejected
                ? "You’re withdrawing your custom payment plan request while some products are rejected and others are still pending."
                : approvedAndRejected
                ? "You’re withdrawing your custom payment plan request while some products are approved and others are rejected."
                : mixedStatusProducts
                ? "You’re withdrawing your custom payment plan request. Some products were approved, others were pending, and a few were rejected."
                : ""}
              {isExpired &&
                "The products have expired. Please withdraw your request to continue."}
            </Text>
          </div>
        );
      case "request-send":
        return (
          <div>
            <Text className="once-withdraw-paragraph">
              Once withdrawn, you won’t be able to send another request for this
              campaign. But don’t worry — you can still proceed with the default
              seller terms whenever you're ready.
            </Text>
            <Row className="products-not-reserved-row">
              <Text className="products-not-reserved-text">
                Products aren’t reserved during this time. Someone else can
                still purchase them.
              </Text>
            </Row>
          </div>
        );
      case "cvv-cvc":
        return (
          <div>
            <Row className="what-is-cvv-number-row">
              <Text className="what-is-cvv-number">What is CVV Number ?</Text>
              <Text className="three-digit-code-text">
                It’s a 3-digit code on the back of your card.
              </Text>
              <Row className="american-card-image">
                <Image src={CVVImage} alt="CVV Example" preview={false} />
              </Row>
            </Row>

            <Row className="have-american-card-row">
              <Text className="what-is-cvv-number">
                Have American Express Card?
              </Text>
              <Text className="three-digit-code-text">
                It’s a 4-digit number on the front, just above your credit card
                number
              </Text>
              <Row className="american-card-image">
                <Image
                  src={AmericanCardImage}
                  alt="CVV Example"
                  preview={false}
                />
              </Row>
            </Row>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div>
      <Modal
        open={termsRequest}
        closable={modalType !== "withdraw" && modalType !== "request-send"}
        title={
          modalType === "withdraw" ? (
            <span className="withdraw-title">Withdraw Custom Terms?</span>
          ) : modalType === "withdraw" ? (
            <span className="withdraw-title">Send Custom Terms Request?</span>
          ) : (
            <></>
          )
        }
        onCancel={handleClose}
        footer={[
          modalType === "withdraw" ? (
            <>
              <Button
                type="primary"
                className="custom-withdraw-button"
                onClick={() => {
                  handleRemoveTerms();
                  handleClose();
                }}
              >
                <Text className="withdraw-request-text">Withdraw Request</Text>
              </Button>

              <Button
                type="primary"
                onClick={handleClose}
                className="keep-wait-button"
              >
                <Text className="keep-wait-button-text">Keep Waiting</Text>
              </Button>
            </>
          ) : modalType === "withdraw" ? (
            <>
              <Button type="primary" className="custom-withdraw-button">
                <Text className="withdraw-request-text">Edit Terms</Text>
              </Button>
              <Button
                type="primary"
                onClick={handleClose}
                className="keep-wait-button"
              >
                <Text className="keep-wait-button-text">Send Request</Text>
              </Button>
            </>
          ) : null,
        ]}
      >
        {renderedComponent()}
      </Modal>
    </div>
  );
};
export default CustomTermsModal;
